export default __webpack_public_path__ + "static/FKScreamer-Black-d33218d1c654c1ee5e70423b905e39e6.woff2";